import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const WORK_IMAGE = "https://images.unsplash.com/photo-1723987135977-ae935608939e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800";

const features = [
  "Solutions informatiques robustes et sécurisées",
  "Assistance constante",
  "Équipe d'intervention rapide",
  "Équipe informatique expérimentée"
];

export default function WorkSection() {
  return (
    <section className="py-24 sm:py-32 bg-white" data-testid="work-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Notre Travail
          </h2>
          <p className="text-lg sm:text-xl text-sky-500 font-medium">
            Des solutions informatiques qui font la différence
          </p>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-slate-600 leading-relaxed">
              Vous recherchez un partenaire informatique de confiance pour gérer l'ensemble de 
              votre établissement ? Contactez-nous.
            </p>
            
            <p className="text-slate-600 leading-relaxed">
              E@tech est un fournisseur de services informatiques de premier plan dans le milieu de 
              l'éducation, qui s'engage à vous offrir les meilleurs services. Nous proposons une 
              multitude de services informatiques, notamment la gestion de projet, l'optimisation des 
              dépenses numériques, cybersécurité, le cloud et la planification de la reprise après 
              sinistre et bien sûr la fourniture de matériel numérique de tout type.
            </p>

            <p className="text-slate-600 leading-relaxed">
              Intéressé(e) ? Prenez rendez-vous pour une consultation gratuite avec nos experts et 
              commençons à élaborer votre solution.
            </p>

            {/* Features List */}
            <ul className="space-y-3 pt-4">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center gap-3 text-slate-700">
                  <CheckCircle size={24} weight="fill" className="text-sky-500 flex-shrink-0" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            {/* CTA Button */}
            <div className="pt-6">
              <Link to="/nous-contacter">
                <Button 
                  className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-3 font-medium rounded-full btn-primary"
                  data-testid="work-cta-btn"
                >
                  Parlons De Votre Projet
                </Button>
              </Link>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={WORK_IMAGE} 
                alt="Équipe travaillant sur un projet éducatif"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-sky-100 rounded-2xl -z-10" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-cyan-100 rounded-2xl -z-10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
